module.exports = __webpack_public_path__ + "img/home_craig-1.28e6c498.jpg";